<template>
  <div>
    <v-navigation-drawer
      v-if="!isViewer"
      permanent
      clipped
      :mini-variant="isMinimized"
      fixed
      width="220"
      app
    >
      <v-list dense>
        <template v-if="isSuperAdmin">
          <v-tooltip
            v-for="adminPage in adminPages"
            :key="adminPage.to"
            :disabled="!isMinimized"
            open-delay="500"
            right
          >
            <template v-slot:activator="{ on, attrs }">
              <v-list-item
                :to="adminPage.to"
                v-bind="attrs"
                v-on="on"
                @contextmenu.prevent="showNavContext($event, adminPage)"
              >
                <v-list-item-action>
                  <v-icon>{{ adminPage.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ $t(adminPage.title) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <span>{{ $t(adminPage.title) }}</span>
          </v-tooltip>
        </template>
        <template v-else>
          <v-tooltip
            v-for="appPage in appPages"
            :key="appPage.to"
            :disabled="!isMinimized"
            open-delay="500"
            right
          >
            <template v-slot:activator="{ on, attrs }">
              <v-list-item
                v-if="permissionCheck(appPage.permission)"
                :to="appPage.to"
                v-bind="attrs"
                v-on="on"
                @contextmenu.prevent="showNavContext($event, appPage)"
              >
                <v-list-item-action>
                  <v-icon>{{ appPage.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ $t(appPage.title) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <span>{{ $t(appPage.title) }}</span>
          </v-tooltip>
        </template>
        <v-divider />
        <v-tooltip
          v-for="settingPage in settingPages"
          :key="settingPage.to"
          :disabled="!isMinimized"
          open-delay="500"
          right
        >
          <template v-slot:activator="{ on, attrs }">
            <v-list-item
              :to="settingPage.to"
              v-bind="attrs"
              v-on="on"
              @contextmenu.prevent="showNavContext($event, settingPage)"
            >
              <v-list-item-action>
                <v-icon>{{ settingPage.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ $t(settingPage.title) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <span>{{ $t(settingPage.title) }}</span>
        </v-tooltip>
      </v-list>
    </v-navigation-drawer>
    <contextMenu
      :items="contextItems"
      :position="contextPos"
      :show="contextShow"
      :selected-item="selectedPage"
      @action="contextAction"
    />
  </div>
</template>

<script>
//Components
import contextMenu from "../Common/ContextMenu.vue";

// Libs
const md5 = require("md5");

export default {
  components: {
    contextMenu,
  },
  data() {
    return {
      adminPages: [
        {
          to: "/account",
          icon: "mdi-shield-home-outline",
          title: "akito.account-title",
        },
        {
          to: "/user",
          icon: "mdi-account-supervisor-circle",
          title: "akito.user-title",
        },
        { to: "/player", icon: "mdi-television", title: "akito.player-title" },
        { to: "/vision", icon: "mdi-update", title: "akito.supervision" },
        {
          to: "/control",
          icon: "mdi-incognito-circle",
          title: "akito.control",
        },
      ],
      appPages: [
        { to: "/home", icon: "mdi-home", title: "navbar.home", permission: 0 },
        {
          to: "/project",
          icon: "mdi-file-document-edit-outline",
          title: "navbar.project",
          permission: 1,
        },
        //{ to: "/fast-project", icon: "mdi-flash", title: "navbar.project", permission: 1 },
        {
          to: "/mediacenter",
          icon: "mdi-image-multiple-outline",
          title: "navbar.mediacenter",
          permission: 3,
        },
        {
          to: "/schedule",
          icon: "mdi-clock-outline",
          title: "navbar.schedule",
          permission: 5,
        },
        {
          to: "/status",
          icon: "mdi-map",
          title: "navbar.status",
          permission: 7,
        },
        {
          to: "/profile",
          icon: "mdi-account-circle",
          title: "navbar.profile",
          permission: 8,
        },
        {
          to: "/stats",
          icon: "mdi-chart-pie",
          title: "navbar.stats",
          permission: 9,
        },
      ],
      settingPages: [
        { to: "/settings", icon: "mdi-cog", title: "navbar.settings" },
        { to: "/help", icon: "mdi-help-circle-outline", title: "navbar.help" },
        // AZURE : page test
        // { to: "/test", icon: "mdi-vlc", title: "navbar.project" }
      ],
      selectedPage: {},
      contextItems: [],
      contextShow: false,
      contextPos: {
        x: 0,
        y: 0,
      },
    };
  },
  computed: {
    isMinimized() {
      return this.$store.state.config.prefs.isMinimized === "true";
    },
    isSuperAdmin() {
      if (md5(this.$store.state.user.aikido) == "bc4634dcd9303d59bace805e02472bcd") {
        return true;
      } else {
        return false;
      }
    },
    isViewer() {
      return this.$store.state.user.permissions == 0;
    },
  },
  created() {
    this.adminCheck();
  },
  methods: {
    adminCheck() {
      if (md5(this.$store.state.user.aikido) == "bc4634dcd9303d59bace805e02472bcd") {
        this.adminPages[0].to = "/minato";
        this.adminPages[1].to = "/akito";
        this.adminPages[2].to = "/kirua";
        this.adminPages[3].to = "/kirito";
        this.adminPages[4].to = "/susano";
      }
    },
    permissionCheck(permChecked) {
      let accepted = false;

      if (permChecked == 0) {
        accepted = true;
      } else {
        if (this.$store.state.user.permissions !== undefined) {
          accepted = this.$store.state.user.permissions.indexOf(permChecked) !== -1;
        }
      }

      return accepted;
    },
    //Affichage du ContextMenu avec un clic droit
    showNavContext(event, obj) {
      this.selectedPage = obj;

      this.makeNavContext();
      this.showContext(event);
    },
    makeNavContext() {
      this.contextItems = [
        {
          icon: "mdi-open-in-new",
          label: this.$t("navbar.go-to"),
          action: "go-to",
        },
      ];
    },
    contextAction(item) {
      switch (item.action) {
        case "go-to":
          this.openPage(this.selectedPage);
          break;
        default:
          break;
      }
    },
    showContext(event) {
      event.stopPropagation();
      this.contextShow = false;

      this.$nextTick(() => {
        this.contextPos = {
          x: event.x,
          y: event.y,
        };

        this.contextShow = true;
      });
    },
    openPage(page) {
      if (page.to != this.$route.path) {
        this.$router.push({
          path: page.to,
        });
      }
    },
  },
};
</script>

<style>
.v-navigation-drawer__content {
  overflow-y: hidden;
}
</style>
